/**Custom JS**/
//$(document).ready(function () {
$(window).on('load', function () {
  setTimeout(function () {
    $("button.ss-recs-prev").attr("aria-label", "Previous");
    $("button.ss-recs-next").attr("aria-label", "Next");
    $("#tabs-menu li a").removeAttr("role");
    $(".rivo-favorites-image svg").attr("aria-hidden", "true");
    $(".rivo-favorites-image svg").attr("aria-labelledby", "title");
    $(".rivo-favorites-image svg").attr("focusable", "false");
    $(".rivo-favorites-image svg").attr("role", "presentation");
    $(".rivo-favorites-image svg").prepend("<title id='wishlist' lang='en'>Wishlist</title>");
    $("rivo-favorite-button svg").attr("aria-hidden", "true");
    $("rivo-favorite-button svg").attr("aria-labelledby", "title");
    $("rivo-favorite-button svg").attr("focusable", "false");
    $("rivo-favorite-button svg").attr("role", "presentation");
    $("rivo-favorite-button svg").prepend("<title id='wishlist' lang='en'>Wishlist</title>");
  }, 5000);    
});
//});

$(".mobile-nav--open").on("click", function(){
  $(".mobile-menu-l1 button:first-child").trigger("click");
})

$(".main-menu-l1Link").on("click", function() {
  let t = $(this).attr("section-name");
  $(this).hasClass("active") || ($(".main-menu-l1Link").removeClass("active"), 
  $('.main-menu-l1Link[section-name="' + t + '"]').addClass("active"),     
  $("#navWrapper").find("nav.mobile-nav-wrapper").hide().removeClass("active"), 
  $("#navWrapper").find("nav.mobile-nav-wrapper[section-name='" + t + "']").show().addClass("active"))
})

$("ul#MobileNav li.mobile-nav__item button").on("click", function(){
  $("#navWrapper").find(".mobile-menu-l1").hide(); 
})
$("ul#MobileNav li.mobile-nav__item button.mobile-nav__return-btn").on("click", function(){
  $("#navWrapper").find(".mobile-menu-l1").show(); 
})





